/* eslint-disable react/no-array-index-key */
import { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import {
  HeadingDescSmall,
  HeadingWithSpaceLarge
} from '../../../Components/Headings';
import HealthCheckLayout from '../healthCheckLayout/HealthCheckLayout';
import { ProfileCard, HealthCheckResultCard } from '../../../Components/Card';
import {
  AncerWithUnderlineSmall,
  SimpleAncerSmall
} from '../../../Components/button';
import { SimpleSliderSmall } from '../../../Components/sliders';
import SuggestedArticles from './suggestedArticles/SuggestedArticles';
import img from '../../../assets/images/svg/doc.svg';
import rightArrow from '../../../assets/images/svg/right-arrow-white.svg';
import HeartGreen from '../../../assets/images/svg/heart-green.svg';
import oxygenGreen from '../../../assets/images/svg/oxygen-green.svg';
import stressLevelYellowGreen from '../../../assets/images/svg/stress-level-yellow.svg';
import respirationRateGreen from '../../../assets/images/svg/respiration-green.svg';
import heartRateGreen from '../../../assets/images/svg/hear-rate-green.svg';
import bmiGreen from '../../../assets/images/svg/bmi-green.svg';
import shareIcon from '../../../assets/images/svg/share-round-border.svg';
import { RightArrowWithBorder } from '../../../Components/icons';
import rightArrowBlue from '../../../assets/images/svg/arrow-right-blue-border.svg';
import './healthCheckReuslt.css';
import { InstantConsultation } from '../../../Components/customModals';

const cardsData = [
  {
    image: img,
    name: 'Dr. Madeeha Asad',
    proff: 'Gynecologist, Obstetrician',
    edu: 'MBBS, FCPS (Gynecology & Obstetrics)',
    exp: 'Experience: 20+ Years'
  },
  {
    image: img,
    name: 'Prof. Dr. Saira Mustehsan',
    proff: 'Internal Medicine Specialist, Family Physician',
    edu: 'M.B.B.S, F.C.P.S. (Medicine), Ph.D',
    exp: ''
  },
  {
    image: img,
    name: 'Dr. Madeeha Asad',
    proff: 'Gynecologist, Obstetrician',
    edu: 'MBBS, FCPS (Gynecology & Obstetrics)',
    exp: 'Experience: 20+ Years'
  },
  {
    image: img,
    name: 'Dr. Madeeha Asad',
    proff: 'Gynecologist, Obstetrician',
    edu: 'MBBS, FCPS (Gynecology & Obstetrics)',
    exp: 'Experience: 20+ Years'
  },
  {
    image: img,
    name: 'Dr. Madeeha Asad',
    proff: 'Gynecologist, Obstetrician',
    edu: 'MBBS, FCPS (Gynecology & Obstetrics)',
    exp: 'Experience: 20+ Years'
  },
  {
    image: img,
    name: 'Dr. Madeeha Asad',
    proff: 'Gynecologist, Obstetrician',
    edu: 'MBBS, FCPS (Gynecology & Obstetrics)',
    exp: 'Experience: 20+ Years'
  },
  {
    image: img,
    name: 'Dr. Madeeha Asad',
    proff: 'Gynecologist, Obstetrician',
    edu: 'MBBS, FCPS (Gynecology & Obstetrics)',
    exp: 'Experience: 20+ Years'
  },
  {
    image: img,
    name: 'Dr. Madeeha Asad',
    proff: 'Gynecologist, Obstetrician',
    edu: 'MBBS, FCPS (Gynecology & Obstetrics)',
    exp: 'Experience: 20+ Years'
  }
];

const scanResult = [
  {
    mode: 'normal',
    progress: 60,
    icon: HeartGreen,
    title: 'Heart Rate',
    secondTitle: '(BPM)',
    detail:
      'Lorem Ipsum is simply dummy text of the printing and typesetting industry.'
  },
  {
    mode: 'normal',
    progress: 50,
    icon: oxygenGreen,
    title: 'Oxygen Saturation',
    secondTitle: '(SOO2%)',
    detail:
      'Lorem Ipsum is simply dummy text of the printing and typesetting industry.'
  },
  {
    mode: 'low',
    progress: 30,
    icon: stressLevelYellowGreen,
    title: 'Stress level',
    secondTitle: '',
    detail:
      'Lorem Ipsum is simply dummy text of the printing and typesetting industry.'
  },
  {
    mode: 'normal',
    progress: 60,
    icon: respirationRateGreen,
    title: 'Respiration Rate',
    secondTitle: '(RPM)',
    detail:
      'Lorem Ipsum is simply dummy text of the printing and typesetting industry.'
  },
  {
    mode: 'normal',
    progress: 60,
    icon: heartRateGreen,
    title: 'Heart Rate Variability',
    secondTitle: '(MS)',
    detail:
      'Lorem Ipsum is simply dummy text of the printing and typesetting industry.'
  },
  {
    mode: 'normal',
    progress: 60,
    icon: bmiGreen,
    title: 'BMI',
    secondTitle: '',
    detail:
      'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
    stages: ['Under Weight', 'Normal', 'Over Weight']
  }
];

function HealthCheckReuslt() {
  const [modal, setModal] = useState('false');
  const items = cardsData.map((card, index) => (
    <ProfileCard card={card} key={index + 1} />
  ));

  function renderSwitch(colorType) {
    if (colorType === 'low') {
      return 'bgYellow';
    }
    if (colorType === 'normal') {
      return 'bgGreen';
    }
    if (colorType === 'high') {
      return 'bgRed';
    }
    return '';
  }

  return (
    <HealthCheckLayout>
      <section className="healthCheckReuslt bgLinghtGray">
        <Container>
          <Row className="scanInfoRow">
            <Col md={4}>
              <HeadingWithSpaceLarge text="HEALTHCHECK RESULT" />
            </Col>
            <Col md={8}>
              <div className="scanIconInfoContainer">
                <HeadingDescSmall text="When Vitals are great" />
                <HeadingDescSmall text="When Vitals are average" />
                <HeadingDescSmall text="When Vitals are super high" />
              </div>
            </Col>
            <Col md={12}>
              <hr />
            </Col>
            <Col md={12}>
              <div className="scanResultBoxesContainer">
                {scanResult.map((result, index) => {
                  // eslint-disable-next-line operator-linebreak
                  const {
                    mode,
                    progress,
                    icon,
                    title,
                    secondTitle,
                    detail,
                    stages
                  } = result;
                  return (
                    <HealthCheckResultCard
                      key={index}
                      icon={icon}
                      title={title}
                      secondTitle={secondTitle}
                      detail={detail}
                      stages={stages}
                      bgColor={renderSwitch(mode)}
                      progress={progress}
                    />
                  );
                })}
              </div>
            </Col>
            <Col md={12}>
              <div className="btnsContainer">
                <SimpleAncerSmall text="SCAN AGAIN" />
                <div>
                  <img src={shareIcon} alt="shareIcon" />
                  <AncerWithUnderlineSmall text="share" />
                </div>
              </div>
            </Col>
            <Col md={12}>
              <HeadingWithSpaceLarge text="DIAGNOSIS" />
              <div className="diagnosisResult bgLightGreen">
                <HeadingDescSmall text="Your vitals are great! Keep up the good health." />
              </div>
              <div className="diagnosisResult bgLightRed">
                <HeadingDescSmall text="All the parameter seems to be very dangerously high." />
              </div>
              <div className="diagnosisResult bgLighttifannyblue">
                <HeadingDescSmall text="Your vitals are good. However, Heart Rate and Oxygen Saturation seems to be high. Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC." />
              </div>
            </Col>
            <Col md={12}>
              <div className="docRecomendContainer">
                <HeadingWithSpaceLarge text="RECOMMENDATION" />
                <div className="mt-3 pb-2">
                  <HeadingDescSmall text="Based on your results, you must seek immediate consultation with a doctor." />
                  <HeadingDescSmall text="Let us help you find the right doctor!" />
                </div>
                <button
                  onClick={() => setModal('m1')}
                  type="button"
                  className="simple_ancer_small"
                >
                  <img src={rightArrow} alt="rightArrow" />
                  START AN INSTANT CONSULTATION NOW
                </button>
              </div>
            </Col>
            <Col md={12}>
              <SuggestedArticles />
            </Col>
            <Col md={12}>
              <div className="sectionTop">
                <HeadingWithSpaceLarge text="TOP DOCTORS" />
                <div className="d-flex align-items-center">
                  <RightArrowWithBorder />
                  <AncerWithUnderlineSmall text="view all" />
                </div>
              </div>
              <Row>
                <Col md={6}>
                  <HeadingDescSmall text="Based on your results, you can consult with one of our top rated doctors. Book an appointment on just one click. It’s simple, secure and fast!" />
                </Col>
                <Col md={6}>
                  <div className="blueAncerContainer">
                    <img src={rightArrowBlue} alt="rightArrowBlue" />
                    <AncerWithUnderlineSmall text="YOU CAN ALSO START AN INSTANT CONSULTATION" />
                  </div>
                </Col>
              </Row>
              <SimpleSliderSmall
                className="profileSliderSmall"
                sliderTitle="Top Rated General Physicians"
              >
                {items}
              </SimpleSliderSmall>
              <Row className="btnRow">
                <Col md={10}>
                  <SimpleAncerSmall text="browse all our doctors">
                    <img src={rightArrow} alt="rightArrow" />
                  </SimpleAncerSmall>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
        <InstantConsultation
          show={modal === 'm1'}
          close={() => setModal(false)}
        />
      </section>
    </HealthCheckLayout>
  );
}

export default HealthCheckReuslt;
